routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tunnel', {
      url: "tunnel",
      template: `<tunnel sh-ctrl="shCtrl"></tunnel>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/tunnel/tunnel.config.js
 **/